import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addForbiddenWord,
    deleteAllForbiddenWordsByCompany,
    downloadFileWithWords,
    getForbiddenWords
} from "../../../../../../../services/company/api";
import Translate from "../../../../../../../components/Translate";
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";
import RedButton from "../../../../../../../components-new/buttons/RedButton";
import {addNotification as addNotificationAction} from "../../../../../../../services/notification/action";
import {connect} from "react-redux";
import {silverInfoStyles} from "../../../../../../../utils/General";
import Input from "../../../../../../../components-new/Input";
import config from "../../../../../../../config";

const containerStyle = {
    padding: '10px',
    margin: '20px auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '800px',
};

const headerStyle = {
    height: '60px',
    padding: '20px 40px',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#A4ADC1',
};

const inputContainerStyle = {
    marginTop: '10px',
    textAlign: 'center',
    alignItems: 'center',
    width: '700px',
    justifyContent: 'center'
};

const fileInputStyle = {
    width: '200px',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
};

class ForbiddenWordsConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forbiddenWords: [],
            selectedFile: null,
            showList: false,
        };
    }

    componentDidMount() {
        const {client} = this.props;
        this.fetchForbiddenWords(client.id);
    }

    fetchForbiddenWords = (companyId) => {
        getForbiddenWords(companyId)
            .then(forbiddenWords => {
                this.setState({forbiddenWords});
            })
            .catch(error => console.error('Error fetching forbidden words:', error));
    };

    handleDeleteAll = () => {
        const {client, addNotification} = this.props;
        deleteAllForbiddenWordsByCompany(client.id)
            .then(() => {
                this.setState({forbiddenWords: []});
                addNotification("deleted", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            })
    }

    handleFileChange = (event) => {
        this.setState({selectedFile: event.target.files[0]});
    };

    handleAddWord = () => {
        const {client, addNotification} = this.props;
        const {selectedFile} = this.state;

        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const fileContent = event.target.result;
                const words = fileContent.split(/\r?\n/).filter(Boolean);
                addForbiddenWord(client.id, words)
                    .then(() => {
                        this.setState({forbiddenWords: words});
                        addNotification("addSuccess", config.notificationLevels.success)
                    })
                    .catch(() => {
                        addNotification("somethingWentWrong", config.notificationLevels.error)
                    })
            };
            reader.readAsText(selectedFile);
        }
    };

    downloadFile = () => {
        const {client} = this.props;
        downloadFileWithWords(client.id)
    }

    toggleListVisibility = () => {
        this.setState(prevState => ({showList: !prevState.showList}));
    };

    render() {
        const {forbiddenWords} = this.state;

        return (
            <div style={containerStyle}>
                <h2 style={headerStyle} onClick={this.toggleListVisibility}>
                    <Translate text={'forbiddenWords'}/>
                </h2>
                <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '20px', textAlign: 'center'}}>
                    <Translate text="forbiddenWordsExplanation"/>
                </h2>
                <div style={inputContainerStyle}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
                        <Input
                            type="file"
                            onChange={this.handleFileChange}
                            style={fileInputStyle}
                            accept=".txt"
                        />
                        {forbiddenWords.length > 0 &&
                            <div>
                                (📄 <Translate text={'attached'}/>)
                            </div>
                        }

                    </div>

                    <br/>

                    <div>
                        <BlueButton
                            styles={{marginRight:'10px'}}
                            width={'125px'}
                            onClick={this.handleAddWord}
                            children={<Translate text={'add'}/>}
                        />
                        <BlueButton
                            styles={{marginRight:'10px'}}
                            width={'250px'}
                            onClick={this.downloadFile}
                        >
                            <Translate text={'download'}/> ({forbiddenWords.length})
                        </BlueButton>
                        {forbiddenWords.length > 0 &&
                            <RedButton
                                width={'250px'}
                                onClick={this.handleDeleteAll}
                                children={<Translate text={'clearAttachedFile'}/>}
                            />
                        }
                    </div>

                </div>
            </div>
        );
    }
}

ForbiddenWordsConfig.propTypes = {
    client: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = {
    addNotification: addNotificationAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForbiddenWordsConfig);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/ForbiddenWordsConfig.jsx